import * as angular from "angular";

import {newsletterDistributionDataTableConfig} from "./newsletter-distribution-data-table/newsletter-distribution-data-table.component";
import {newsletterDistributionConfig} from "./newsletter-distributions.component";
import {viewNewsletterDistributionConfig} from './view-newsletter-distribution/view-newsletter-distribution.component';
import {sendAgainDialogConfig} from './send-again-dialog/send-again-dialog.component';
import {previewLinkDialogConfig} from './preview-link-dialog/preview-link-dialog.component';
import NewsletterDistributionService from "./newsletter-distributions-state.service";
import SendAgainDialogService from "./send-again-dialog/send-again-dialog.service";
import PreviewLinkDialogService from "./preview-link-dialog/preview-link-dialog.service";
import OutputConfig from '../../config/config';

export default angular
    .module('mw.newsletter.distributions', [
            'MW.OutputNewsletter.OutputNewsletterDistribution',
            'MW.OutputNewsletter.OutputNewsletterDistributionService',
            'MW.OutputNewsletter.OutputNewsletter',
            'MW.OutputNewsletter.OutputNewsletterService',
            'MW.OutputNewsletter.RecipientListsService',
            'MW.Framework.AnalyticsService',
            'MW.Framework.AnalyticsConstants',
            'MW.Framework.CoreUserService',
            'MW.Framework.CoreCompanyService',
            'MW.Framework.AppBarTitleService',
            'MW.Framework.MomentService',
            'MW.Configuration'
        ]
    )
    .component(newsletterDistributionDataTableConfig.selector, newsletterDistributionDataTableConfig)
    .component(newsletterDistributionConfig.selector, newsletterDistributionConfig)
    .component(viewNewsletterDistributionConfig.selector, viewNewsletterDistributionConfig)
    .component(sendAgainDialogConfig.selector, sendAgainDialogConfig)
    .component(previewLinkDialogConfig.selector, previewLinkDialogConfig)
    .service('OutputConfig', OutputConfig)
    .service('NewsletterDistributionService', NewsletterDistributionService)
    .service('SendAgainDialogService', SendAgainDialogService)
    .service('PreviewLinkDialogService', PreviewLinkDialogService)
    .name;



/** WEBPACK FOOTER **
 ** ./apps-ts/outputs/src/app/newsletter-distributions/newsletter-distributions.module.ts
 **/